import { useHistory, useLocation } from "react-router-dom";
function normalizeValue(value) {
    if (value == null) {
        return [];
    }
    return (Array.isArray(value) ? value : [value]).filter(Boolean);
}
function applyFilterChanges(search, changes) {
    var params = new URLSearchParams(search);
    Object.entries(changes).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        params.delete(key);
        normalizeValue(value).forEach(function (item) {
            params.append(key, item);
        });
    });
    return params;
}
export function useUrlFilters() {
    var history = useHistory();
    var location = useLocation();
    var getFilter = function (key) {
        var _a;
        var params = new URLSearchParams(location.search);
        return (_a = params.get(key)) !== null && _a !== void 0 ? _a : undefined;
    };
    var getMultiFilter = function (key) {
        var params = new URLSearchParams(location.search);
        return params.getAll(key);
    };
    var setFilter = function (key, value) {
        var _a;
        var params = applyFilterChanges(location.search, (_a = {}, _a[key] = value, _a));
        history.replace({ pathname: location.pathname, search: params.toString() });
    };
    var setMultiFilter = function (key, values) {
        var _a;
        var params = applyFilterChanges(location.search, (_a = {}, _a[key] = values, _a));
        history.replace({ pathname: location.pathname, search: params.toString() });
    };
    var setFilters = function (changes) {
        var params = applyFilterChanges(location.search, changes);
        history.replace({ pathname: location.pathname, search: params.toString() });
    };
    var setMultiFilters = function (changes) {
        var params = applyFilterChanges(location.search, changes);
        history.replace({ pathname: location.pathname, search: params.toString() });
    };
    var clearFilters = function () {
        history.replace({ pathname: location.pathname, search: "" });
    };
    return {
        getFilter: getFilter,
        getMultiFilter: getMultiFilter,
        setFilter: setFilter,
        setMultiFilter: setMultiFilter,
        setFilters: setFilters,
        setMultiFilters: setMultiFilters,
        clearFilters: clearFilters,
        search: location.search,
    };
}
